var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgMobileAircraft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 18",
    fill: "#98A1BD",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M6.789 17.125h-1.04a.625.625 0 01-.57-.883l2.519-5.557-3.781-.083-1.38 1.67c-.262.33-.472.478-1.007.478h-.7a.69.69 0 01-.574-.276c-.093-.125-.184-.338-.095-.64L.935 9.06a.714.714 0 01.02-.068.579.579 0 01-.02-.062L.16 6.14a.688.688 0 01.1-.628.657.657 0 01.531-.262h.74c.399 0 .787.18 1.015.469l1.35 1.642 3.802-.056L5.18 1.758a.625.625 0 01.568-.883H6.8a.977.977 0 01.756.383l4.885 5.937 2.256-.06c.166-.008.623-.011.73-.011 2.158.001 3.447.702 3.447 1.876 0 .37-.148 1.055-1.136 1.49-.583.258-1.361.389-2.313.389-.104 0-.56-.003-.729-.012l-2.256-.06-4.897 5.937a.977.977 0 01-.754.381z"
  })));
}
export default SvgMobileAircraft;